import { AssetSubTypologies, AssetTypologies, AssetUses, ValidationTypes } from '../enums/backend.enums';

export interface ReducerByTabInitialDetailsFilter {
  requesters?: ValidationTypes[];
  uses?: AssetUses[];
  typologies?: AssetTypologies[];
  subTypologies?: AssetSubTypologies[];
}
